import axios from 'axios';
import moment from 'moment';

export default {
  loadStatistics({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        const config = state.config;
        const request = `${config.module}?startDate=${moment(config.startDate).format('YYYY-MM-DD')}&endDate=${moment(config.endDate).format('YYYY-MM-DD')}`;
        const response = await axios.get(request);
        commit('setData', response.data);
        resolve();
      // Catch errors
      } catch (error) {
      // Log action and status.
        console.warn(error);
        // Reject promise
        reject(error);
      }
    });
  },
  loadStatisticsConfig({ commit }, config) {
    commit('updateConfig', config);
  },
};
